let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fbEZS")).then(() => parcelRequire('5vD7r'));